import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArticlesModal } from "./article.js";
import { Map } from "./map.js";
import { SearchInput } from "./search-input.js";
import "./App.css";

export function App() {
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();

  function openMapItem(articleTitle) {
    navigate(articleTitle);
  }

  return (
    <div className="app">
      <>
        <SearchInput setSearchInput={setSearchInput} />
        <ArticlesModal />
        <Map openItem={openMapItem} searchInput={searchInput} />
      </>
    </div>
  );
}

export default App;
